import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tagId: 0,
  currentPage: 1,
  sortType: { name: "more popular", sortProperty: "rating" },
};

export const filterSlice = createSlice({
  name: "filter",
  initialState: initialState,
  reducers: {
    selectTagId: (state, action) => {
      state.tagId = action.payload;
    },
    selectSort: (state, action) => {
      state.sortType = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    // Lesson 16
    // setFilters :(state, action) {
    //   state.sortType = action.payload.sortType;
    //   state.currentPage = Number(action.payload.currentPage);
    //   state.categoryId = Number(action.payload.categoryId);
    // },
  },
});

export const { selectTagId, selectSort, setCurrentPage } = filterSlice.actions;

export default filterSlice.reducer;
